__webpack_require__.b = new URL("./", import.meta.url);;

      // object to store loaded and loading chunks
      // undefined = chunk not loaded, null = chunk preloaded/prefetched
      // [resolve, Promise] = chunk loading, 0 = chunk loaded
      var installedChunks = {35106: 0,59299: 0,90867: 0,91433: 0,96188: 0,};
      var installChunk = (data) => {
    var __rspack_esm_ids = data.__rspack_esm_ids;
    var moreModules = data.__webpack_modules__;
    var __rspack_esm_runtime = data.__rspack_esm_runtime;
    // add "modules" to the modules object,
    // then flag all "ids" as loaded and fire callback
    var moduleId, chunkId, i = 0;
    for (moduleId in moreModules) {
        if (__webpack_require__.o(moreModules, moduleId)) {
            __webpack_require__.m[moduleId] = moreModules[moduleId];
        }
    }
    if (__rspack_esm_runtime) __rspack_esm_runtime(__webpack_require__);
    for (; i < __rspack_esm_ids.length; i++) {
        chunkId = __rspack_esm_ids[i];
        if (__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
            installedChunks[chunkId][0]();
        }
        installedChunks[__rspack_esm_ids[i]] = 0;
    }
    
};

        __webpack_require__.f.j = function (chunkId, promises) {
          // import() chunk loading for javascript
var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
if (installedChunkData !== 0) { // 0 means "already installed".'
    // a Promise means "currently loading".
    if (installedChunkData) {
        promises.push(installedChunkData[1]);
    } else {
        if (!/^(4(4201|6226|6633|9072)|2(7(365|525|704)|0753|1679|3481|6698|9523|9777)|5(1(28|371|640|843)|(317|590|703|71)1|(383|636|929)9|2425|4004|573|6517)|6(0(336|396|761)|(11|88)27|1356|3574|6064|7638|9242)|1(3(18|502|63|670)|(235|287|498|766)2|0524|0690|1275|1833|4254|9015)|8(7((17|62|8)6|271|932)|6(495|583|669)|0209|4182|9065)|7(1(849|947|991)|8(112|29|72)|3(09|125|340)|0785|2691|4759|646)|3(8(797|832|963)|7(016|220|342|773|814)|3(27|291|403|959|994)|1982|2515|5106|5373|6328|9621)|9((3|550|785)6|0867|1433|1948|2457|331|4762|5159|6188|6773|7179|9272))$/.test(chunkId)) {
            // setup Promise in chunk cache
            var promise = import("./" + __webpack_require__.u(chunkId)).then(installChunk, (e) => {
                if (installedChunks[chunkId] !== 0) installedChunks[chunkId] = undefined;
                throw e;
            });
            var promise = Promise.race([promise, new Promise((resolve) => {
                installedChunkData = installedChunks[chunkId] = [resolve];
            })]);
            promises.push(installedChunkData[1] = promise);
        }
        else installedChunks[chunkId] = 0;

    }
}
        }
        
        __webpack_require__.C = installChunk;
        // no on chunks loaded
// no HMR
// no HMR manifest
